<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/what_new/what_new/what_new_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ "what_new.Gallery" | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/what-new/1">{{ "what_new.What's New" | translate }}</a>
                    </li>      
                    <li class="nav-item active">
                        <a class="nav-link" href="/gallery">{{ 'what_new.Gallery' | translate }}</a>
                    </li>     
                </ul>
            </div>
        </nav>
        <div class="gallery">
            <div class="button-tab">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-1"></div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-5">
                        <button type="button" class="btn btn-primary active"><a href="gallery" class="active">{{ 'what_new.Images' | translate }}</a></button>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-4 col-5">
                        <button type="button" class="btn btn-primary mt-auto"><a href="gallery/video">{{ 'what_new.Videos' | translate }}</a></button>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-2 col-1"></div>
                </div>
            </div>
            <div class="image-album">
                <div class="row justify-content-center">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-11 mb-3" *ngFor="let album of albumData">
                        <div class="card h-100">
                            <img class="card-img-top" [src]="baseApiUrl + '/' + album.image" alt="Card image cap" loading="lazy">
                            <div class="card-body d-flex flex-column">
                                <h5 class="card-title" *ngIf="currentLanguage === 'en'">{{ album.title }}</h5>
                                <h5 class="card-title" *ngIf="currentLanguage === 'kh'">{{ album.title_kh }}</h5>
                                <p class="card-text">{{ album.total_images }} {{ 'what_new.Photos' | translate }}</p>
                                <a href="/gallery/gallery-detail/{{ album.id }}" target="_blank" class="btn btn-primary mt-auto">{{ 'what_new.View All' | translate}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
